import {
  EditOutlined as EditIcon,
  Image as ImageIcon,
  KeyboardArrowDown,
} from '@mui/icons-material';
import { Dropdown } from '@sb/cc-design-system';
import { DropdownSelection } from '@sb/cc-design-system/dist/components/Dropdown/Dropdown.interface';
import { lang } from 'src/utils';

import type { BulkActionButtonProps } from './BulkActionButton.interface';

type MenuActionType = 'edit-cod-messaging' | 'bulk-replace';

interface DropdownOption {
  value: MenuActionType;
  label: string;
  icon?: React.ReactNode;
}

export const BulkActionButton = ({
  onEditCODMessaging,
  onBulkReplace,
  disabled = false,
  dropdownStyles,
}: BulkActionButtonProps) => {
  // Build options based on available callbacks
  const dropdownOptions: DropdownOption[] = [];

  if (onEditCODMessaging) {
    dropdownOptions.push({
      value: 'edit-cod-messaging',
      label: lang.editCODMessaging,
    });
  }

  if (onBulkReplace) {
    dropdownOptions.push({
      value: 'bulk-replace',
      label: lang.replaceComponents,
      icon: <ImageIcon fontSize="small" />,
    });
  }

  const handleDropdownChange = (value: DropdownSelection) => {
    if (value === 'edit-cod-messaging' && onEditCODMessaging) {
      onEditCODMessaging();
    } else if (value === 'bulk-replace' && onBulkReplace) {
      onBulkReplace();
    }
  };

  // Only render if there are options to display
  if (dropdownOptions.length === 0) {
    return null;
  }

  return (
    <Dropdown
      useButtonTrigger
      triggerStartIcon={<EditIcon />}
      triggerEndIcon={<KeyboardArrowDown />}
      options={dropdownOptions}
      onChange={handleDropdownChange}
      disabled={disabled}
      showOptionIcon
      placeholder={lang.bulkAction}
      menuWidth={180}
      menuBorderRadius={20}
      value={lang.bulkAction}
      buttonVariant="outlined-secondary-1"
      buttonSize="sm"
      triggerCustomStyles={dropdownStyles}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
    />
  );
};
